<script>
export default {
  name: 'PillsDuplicates',
  props: {
    itemRow: { type: [String, Number, Object, Array], default: null },
  },
  data() {
    return {
      item: this.itemRow,
    }
  },
}
</script>

<template>
  <div>
    <span
      v-if="this.itemRow.duplicate === 1"
      class="badge"
      :class="{
        'badge-soft-pdp': this.itemRow.duplicate === 1,
      }"
      >Has Duplicate</span
    >
    <span
      v-else-if="this.itemRow.duplicate === 0"
      class="badge"
      :class="{
        'badge-soft-warning': this.itemRow.duplicate === 0,
      }"
      >It has no duplicate</span
    >
    <span
      v-if="this.itemRow.duplicate === 2"
      class="badge"
      :class="{
        'badge-soft-info': this.itemRow.duplicate === 2,
      }"
      >Duplicated</span
    >
  </div>
</template>

<style scoped>


.badge-soft-info {
  color: #259cb5 !important;
  background-color: rgba(37, 194, 227, 0.2);
}

.badge-soft-pdp {
  color: #a243d3 !important;
  background-color: rgb(162 67 211 / 20%);
}
</style>